import * as Yup from "yup";
import { validateCharacterLimitWithContext } from "../../../helpers/formBodyCharacterLimitValidation";

export const schema = Yup.object().shape({
  group_name: Yup.string().required("Debes indicar el nombre de tu grupo."),
  creator_name: Yup.string().required("Debes indicar el nombre del creador del grupo."),
  // cover_pic: Yup.array().nullable(),
  group_video: Yup.array().nullable(),
  brief: Yup.string()
    .nullable()
    .required("Agrega una descripción a tu membresía.")
    .test(
      'character-limit',
      'No puedes usar más de caracteres', // El mensaje se maneja dinámicamente en la función
      function (value) {
        return validateCharacterLimitWithContext.call(this, value, 10000); // 1000 caracteres máximo
      }
    ),
  this_is_for_me: Yup.string()
    .nullable()
    .test(
      'character-limit',
      'No puedes usar más de caracteres', // El mensaje se maneja dinámicamente en la función
      function (value) {
        return validateCharacterLimitWithContext.call(this, value, 10000); // 1000 caracteres máximo
      }
    ),
  group_perks: Yup.array()
    .of(Yup.string().max(300, 'Cada beneficio debe tener como máximo 300 caracteres.'))
    .test('not-empty', 'Debe haber al menos un beneficio.', arr => {
      return Array.isArray(arr) && arr.some(item => item && item.trim() !== '');
    }),
  group_type: Yup.string().required("Indica el tipo de grupo que vas a crear (membresía o taller)."),

  // Validaciones de Door Programming
  doorMode: Yup.string().nullable(),
  openNow: Yup.boolean().nullable(),
  closeNow: Yup.boolean().nullable(),
  includeClosing: Yup.boolean().nullable(),
  subscriptions_opening_date: Yup.string()
    .nullable()
    .when(['doorMode', 'openNow'], {
      is: (doorMode, openNow) => doorMode === 'open_subscriptions' && !openNow,
      then: (schema) => schema.required('Debes indicar una fecha de apertura o marcar "Abrir ahora"')
        .test(
          'opening-future',
          'La fecha y hora de apertura deben ser posteriores a la fecha y hora actuales',
          function (value) {
            if (!value) return true;
            const openingDate = new Date(value);
            const now = new Date();
            return openingDate.getTime() > now.getTime();
          }
        ),
      otherwise: (schema) => schema.nullable()
    }),
  subscriptions_closing_date: Yup.string()
    .nullable()
    .when(['doorMode', 'closeNow', 'includeClosing'], {
      is: (doorMode, closeNow, includeClosing) =>
        (doorMode === 'close_subscriptions' && !closeNow) ||
        (doorMode === 'open_subscriptions' && includeClosing),
      then: (schema) => schema.required('Debes indicar una fecha de cierre o marcar la opción correspondiente')
        .test(
          'closing-future',
          function (value) {
            if (!value) return true;

            const { subscriptions_opening_date } = this.parent;
            const closingDate = new Date(value);
            const now = new Date();

            // Comparar timestamps (milisegundos) para incluir hora completa
            if (!subscriptions_opening_date) {
              // Si no hay fecha de apertura (checkbox "Abrir ahora" marcado)
              if (closingDate.getTime() <= now.getTime()) {
                return this.createError({
                  message: 'La fecha y hora de cierre deben ser posteriores a la fecha y hora actuales'
                });
              }
            } else {
              // Si hay fecha de apertura, comparar con ella
              const openingDate = new Date(subscriptions_opening_date);
              if (closingDate.getTime() <= openingDate.getTime()) {
                return this.createError({
                  message: 'La fecha y hora de cierre deben ser posteriores a la fecha y hora de apertura'
                });
              }
            }

            return true;
          }
        ),
      otherwise: (schema) => schema.nullable()
    }),
  // plan: Yup.object().shape({
  //   type: Yup.string().required('La propiedad "plan type" es obligatorio'),
  //   currency: Yup.string().required('La tipo de moneda es obligatoria.'),
  //   price: Yup.number().required('Indica el precio de tu taller.').min(1, 'El precio es incorrecto.'),
  //   showable_secondary_currency: Yup.string().nullable(),
  //   billing_cycles: Yup.number().nullable(),
  //   period_unit: Yup.string().nullable(),
  //   period: Yup.number().nullable(),
  //   show_in_page: Yup.boolean().required('La propiedad "plan show_in_page" es obligatoria'),
  //   status: Yup.string().required('La propiedad "plan status" es obligatorio'),
  // }),
});

interface FormValues {
  group_name: string,
  creator_name: string,
  // cover_pic?: object[];
  group_video?: object[];
  brief: string,
  group_perks: string[],
  group_type: 'membership' | 'experience',
  // plan: {
  //   type: 'subscription' | 'charge',
  //   currency: "ARS" | "EUR" | "USD",
  //   showable_secondary_currency: "MXN" | "CLP" | "ARS" | "COP" | "UYU" | "PEH" | "EUR" | "USD" | "PAB",
  //   show_local_price: string[],
  //   price?: number,
  //   billing_cycles: null,
  //   period_unit: 'month' | null,
  //   period: 1 | null,
  //   show_in_page: true,
  //   status: "active",
  // }
}

export const initialValues: FormValues = {
  group_name: '',
  creator_name: '',
  brief: '',
  group_perks: [''],
  group_type: 'experience',
  // plan: {
  //   type: 'subscription',
  //   currency: "ARS",
  //   //price: 0,
  //   showable_secondary_currency: "USD",
  //   show_local_price: [],
  //   billing_cycles: null,
  //   period_unit: "month",
  //   period: 1,
  //   show_in_page: true,
  //   status: "active",
  // }
};